import 'G6'

// 开始按钮
G6.registerNode('start', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="start"><i class="el-icon-caret-right"></i></div><div class="node-name node-start-name">开始</div></div>')
    return dom
  }
}, 'html')
// 添加按钮
G6.registerNode('addNodeBtn', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="add-node-btn">+</div>')
    return dom
  }
}, 'html')
// 微信回复node
G6.registerNode('wechatReplyNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-wechat"><div class="node-name node-wechatreply-name">微信回复</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 短信node
G6.registerNode('smsNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    console.log('model')
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-duanxin"><div class="node-name">短信</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 客户属性node
G6.registerNode('customerAttrNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-kehu"><div class="node-name node-wechatreply-name">客户属性</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 加入群组node
G6.registerNode('addGroupNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-jiarubanji"><div class="node-name node-wechatreply-name">加入群组</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 移出群组node
G6.registerNode('removeGroupNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-huiyuanyichu"><div class="node-name node-wechatreply-name">移出群组</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 模板消息node
G6.registerNode('templateMessageNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-navicon-dxmbwh"><div class="node-name node-wechatreply-name">模板消息</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 发送红包node
G6.registerNode('sendRedPacketsNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-hongbao"><div class="node-name node-wechatreply-name">发送红包</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 属性判断node
G6.registerNode('attrJudgeNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-gongrenshuxing" style="background: #D893F2"><div class="node-name node-wechatreply-name">属性判断</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 事件判断node
G6.registerNode('eventJudgeNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-shijianguanli" style="background: #D893F2"><div class="node-name node-wechatreply-name">事件判断</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 属性多分支node
G6.registerNode('attrBranchNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-84" style="background: #D893F2"><div class="node-name node-attrBranch-name">属性多分支</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 等待node
G6.registerNode('waitNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-dengdai" style="background: #FF8888"><div class="node-name">等待</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
// 结束node
G6.registerNode('endNode', {
  cssSize: true, // 该配置项设置为 true 时，则节点不受 node size 控制
  getHtml: function(cfg) {
    let model = cfg.model
    let dom = G6.Util.createDOM('<div class="position-content"><div class="node-item-icon iconfont icon-zhaobiaojieshu" style="background: #FF8888"><div class="node-name">结束</div><i class="el-icon-close closeBtn"></i></div></div>')
    return dom
  }
}, 'html')
